export default __webpack_public_path__ + "vqa432b9a.png";